// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3805":"526d080c77a349f67f77","6110":"bdf3f1e22a95744b75dd","8701":"ad3e2e33832e206f74aa"}[chunkId] + ".js";
};